import { TextColorProps, TextFontProps } from "./commonProps";
import {
  textColorClassName,
  textColorPrimaryClassName,
  textFontClassName,
  transitionClassName,
} from "./commonClassNames";

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement> &
  TextColorProps &
  Pick<TextFontProps, "uppercase" | "size"> & { className?: string };

export const Label: React.FC<LabelProps> = ({
  children,
  accent,
  htmlFor,
  size = "base",
  primary,
  uppercase,
  white,
  style,
  className,
}) => {
  const combinedClassName = [
    "select-none",
    htmlFor ? `cursor-pointer hover:${textColorPrimaryClassName}` : "",
    textColorClassName({ accent, primary, white }),
    textFontClassName({ font: "medium", uppercase, size }),
    transitionClassName({ colors: true }),
    className ?? "",
  ].join(" ");

  return (
    <label className={combinedClassName} htmlFor={htmlFor} style={style}>
      {children}
    </label>
  );
};
